import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from 'react-router-dom';

export default function NotificationsPanel({ open, notifications, onClose }) {
  // ⬅️ يقفل لما تدوسي بره البانيل
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (e.target.closest("#notifications-panel") === null && open) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <>
          {/* خلفية شفافة في الموبايل */}
          <motion.div
            className="fixed inset-0 bg-black/30 z-40 lg:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* البانيل نفسه */}
          <motion.div
            id="notifications-panel"
            initial={{ opacity: 0, y: -10, x: 0 }}
            animate={{
              opacity: 1,
              y: 0,
              x: 0,
            }}
            exit={{ opacity: 0, y: -10, x: 0 }}
            transition={{ duration: 0.25 }}
            className="
              z-50 
              bg-white dark:bg-[#1A1A1B] shadow-lg overflow-hidden
              lg:absolute lg:right-0 lg:mt-[320px] lg:w-80 lg:rounded-xl
              fixed top-0 right-0 h-full w-72 lg:h-auto lg:top-auto
            "
          >
            {/* Header */}
            <div className="p-3 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
              <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-200">
                Notifications
              </h3>
              <button
                onClick={onClose}
                className="text-xs text-gray-500 hover:text-gray-800 dark:hover:text-gray-300"
              >
                ✕
              </button>
            </div>

            {/* Notifications List */}
            <ul className="max-h-60 overflow-y-auto lg:max-h-72">
              {notifications && notifications.length > 0 ? (
                notifications.map((n) => (
                  <li
                    key={n.id}
                    className="px-4 py-3 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#2D2D2D] cursor-pointer"
                  >
                    <p className="font-medium">{n.text}</p>
                    <span className="text-xs text-gray-500">{n.time}</span>
                  </li>
                ))
              ) : (
                <li className="px-4 py-3 text-sm text-gray-500 text-center">
                  No notifications
                </li>
              )}
            </ul>

            {/* Footer */}
            <div className="p-2 text-center border-t border-gray-200 dark:border-gray-700">
              <button className="text-sm text-blue-600 hover:underline">
                <Link to="/notifications" onClick={onClose}>
                View all</Link>
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
